import { getWorkflowState } from '@/features/document/stores/workflowStore';
import { useEmbedStore, type EmbedTarget } from '@/features/validate/stores/embedStore';
import { TargetSaveAction } from '@/shared/api/generated-types';

const lockedDestinationId = (): string | null =>
  getWorkflowState().submissionResults.savedValidationId ?? null;

export const chooseEmbedTarget = (target: EmbedTarget) =>
  useEmbedStore.getState().chooseTarget(target, lockedDestinationId());

export const chooseNewValidation = () =>
  useEmbedStore.getState().chooseNewValidation(lockedDestinationId());

export interface SaveTarget {
  validationId: string;
  action: TargetSaveAction;
  preserveReference?: boolean;
  chosen: boolean;
}

export const resolveSaveTarget = (): SaveTarget | null => {
  const { target, targetAction, preserveReference, targetChosen } = useEmbedStore.getState();
  if (target) {
    return {
      validationId: target.validationId,
      action: targetAction,
      chosen: targetChosen,
      preserveReference: targetAction === TargetSaveAction.Replace ? preserveReference : undefined,
    };
  }

  const locked = lockedDestinationId();
  return locked ? { validationId: locked, action: TargetSaveAction.Infer, chosen: false } : null;
};
